<script lang="ts">
    import { isEqual } from 'lodash-es'

    import { gettext as _ } from 'hydria/services/gettext'
    import { notify } from 'hydria/services/notifications'
    import { simpleFetch } from 'hydria/services/session'

    import LoadingPattern from 'hydria/components/LoadingPattern.svelte'

    interface Props {
        userId: string
    }

    let { userId }: Props = $props()

    interface Form {
        exempted: boolean
        reason?: string
    }
    let saved: Form | undefined = $state()
    let form: Form | undefined = $state()
    let effForm: Form | undefined = $derived(form == null ? undefined : { exempted: form.exempted, reason: form.exempted ? form.reason : undefined })

    let changed = $derived(!isEqual(saved, effForm))

    let loading = $state(true)
    let error = $state(false)
    let saving = $state(false)
    let loadedUserId: string | undefined | null = $state()

    async function load(userId: string) {
        const userIdToLoad = userId ? userId : ''
        if (loadedUserId == userIdToLoad) return
        loadedUserId = userIdToLoad

        loading = true

        try {
            const r = await simpleFetch('GET', `/json/ecom/1/user-tax-exemption/${userId}`)
            saved = {
                exempted: r.data.exempted,
                reason: r.data.reason,
            }
            form = { ...saved }
        } catch (e: any) {
            console.error('Failed to load tax status:', e)
            if (e && e.status == 404) {
                // This is OK, the user simply doesn’t have custom data yet.
                saved = {
                    exempted: false,
                    reason: undefined,
                }
                form = { ...saved }
            } else {
                notify({
                    type: 'danger',
                    title: $_('Exemption de taxes'),
                    text: 'L’information de taxation n’a pas pu être chargée.',
                })
                error = true
            }
        }

        loading = false
    }

    async function save() {
        saving = true

        try {
            const r = await simpleFetch('PUT', `/json/ecom/1/user-tax-exemption/${userId}`, { ...effForm })
            saved = {
                exempted: r.data.exempted,
                reason: r.data.reason,
            }
            form = { ...saved }
            notify({
                type: 'success',
                title: $_('Exemption de taxes'),
                text: 'Information sauvegardée.',
            })
        } catch (e) {
            console.error('Failed to save tax status:', e)
            notify({
                type: 'danger',
                title: $_('Exemption de taxes'),
                text: 'L’information de taxation n’a pas pu être sauvegardée.',
            })
            error = true
        }

        saving = false
    }

    $effect(() => {
        load(userId)
    })
</script>

<div class="card">
    <div class="card-title text-primary">{$_('Exemption de taxes')}</div>
    {#if loading || !form}
        <div class="card-body"><LoadingPattern pattern={['x', 'x', 'x']} /></div>
    {:else if error}
        <div class="card-body text-danger">L’information n’a pas pu être chargée.</div>
    {:else}
        <div class="card-body">
            <form
                onsubmit={(e) => {
                    e.preventDefault()
                    save()
                }}
                class="d-grid gap-2"
            >
                <div class="row">
                    <label for="tlde-taxe" class="col-sm-3 col-form-label">{$_('Exempté')}</label>
                    <div class="col-sm-9">
                        <div class="radio">
                            <label>
                                <input type="radio" value={false} bind:group={form.exempted} disabled={saving} />
                                Non exempté
                            </label>
                        </div>

                        <div class="radio">
                            <label>
                                <input type="radio" bind:group={form.exempted} value={true} style="margin-top: 7px;" disabled={saving} /> Exempté, raison optionnelle :
                                <div style="display: inline-block; width: 16em; vertical-align: middle;">
                                    <input type="text" class="form-control" placeholder="Raison / ID" disabled={!form.exempted || saving} bind:value={form.reason} />
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="offset-sm-3 col-sm-9">
                        <p class="help-text">
                            {$_('Note : n’est pas affiché à l’utilisateur, mais s’il ouvre la console et regarde l’information du réseau, il peut tout de même voir la raison.')}
                        </p>
                        {#if saving}
                            <button type="button" class="btn btn-info" disabled
                                ><div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
                                Un moment…</button
                            >
                        {:else}
                            <button type="submit" class="btn btn-outline-secondary" disabled={!changed}>{$_('Save')}</button>
                        {/if}
                    </div>
                </div>
            </form>
        </div>
    {/if}
</div>
